import { selectorFamily, useRecoilValue } from 'recoil';
import { convertDispute } from 'functions';
import { useDisputeParam } from 'hooks';
import { DisputeService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { DisputeDetail } from 'types';

export const disputeDetails = selectorFamily<DisputeDetail, string>({
    key: 'disputeDetails',
    get: (disputeId) =>
        async ({ get }) => {
            get(refreshState(disputeDetails(disputeId).key));
            if (get(isAuthenticated)) {
                const service = new DisputeService();
                const data = await service.getDisputeDetails(disputeId);
                if (data) {
                    return convertDispute(data);
                }
            }
            return {} as DisputeDetail;
        }
});

export const useDisputeDetails = (disputeNumber?: string) => {
    const disputeId = useDisputeParam();
    return useRecoilValue(disputeDetails(disputeNumber ?? disputeId));
};

export const useRefreshDisputeDetails = (disputeId: string) => useSetRefreshState(disputeDetails(disputeId));